export enum PlansEnum {
    ESSENTIAL = 'Essential',
    PROFESSIONAL = 'Professional',
    PREMIUM = 'Premium',
    OLD = 'Old',
    STABLE_VERSION = 'v4'
}
